export default {
    ux: (state) => {
        return state.ux
    },
}